import * as Clusterer from "../libraries/markerclusterer";

const mapStyles = [
    {
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5",
            },
        ],
    },
    {
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#616161",
            },
        ],
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#f5f5f5",
            },
        ],
    },
    {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#bdbdbd",
            },
        ],
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee",
            },
        ],
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#757575",
            },
        ],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5",
            },
        ],
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#cccccc",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#888888",
            },
        ],
    },
    {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#cccccc",
            },
            {
                weight: 3,
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#666666",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on",
            },
            {
                weight: 1,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#dadada",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#cccccc",
            },
            {
                weight: 6,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#666666",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#cccccc",
            },
            {
                weight: 1,
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#cccccc",
            },
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#666666",
            },
            {
                weight: 1,
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on",
            },
        ],
    },
    {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5",
            },
        ],
    },
    {
        featureType: "transit.line",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#cccccc",
            },
        ],
    },
    {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee",
            },
        ],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#888888",
            },
        ],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#ffffff",
            },
        ],
    },
];

export function init() {
    initSimpleMaps();
    initMultiMarkerMaps();
}

export function initSimpleMaps() {
    const maps = document.querySelectorAll(".js-map"),
        mapOpts = {
            zoom: 15,
            scrollwheel: false,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scaleControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
            styles: mapStyles,
        };

    // If we have a map, build it!
    if (maps.length) {
        maps.forEach((map) => {
            const svgMarker = {
                path: "M2529.1 647c-111.72 17.91-1005.93 158.08-1005.93 158.08s.51-2.91.76-4.43C1587.05 418.75 1353.83 0 1057.69 0 787.84 0 584.28 260.38 857.28 760.61c23.68 43.4 47.35 85 77.47 136.15C469.15 969.46.4 1039 .4 1164.54c0 124.07 290.13 236.29 612 335 212.75 65.17 621.75 183.46 621.75 183.46s-268.32 296.6-434.47 485.69c-75.15 85.51-108.1 144.92-108.1 197.25 0 51.76 41.82 88.64 94.16 88.64 155.57 0 707.62-236.9 864.62-422.08l199 314h468.15l-381.44-605.13c417.83-93.31 584.32-264.64 584.32-355.36 0-127.15-237.7-242.55-951.21-286.92 278.55-78.44 918.47-249.72 1045.59-292.58 80-27 98.09-89.74 71.22-128.16-21.33-30.49-75.13-44.47-156.89-31.35zM1311.75 345.54c46.3 115.53 5.67 256.92-33.37 352.46L1177 537.19c-21.66-38.18-38.79-70.06-49.36-93.81-145.17-326.13 67.36-389.25 184.11-97.84zm-838.46 827.68c0-48.07 388.1-118.19 541.55-142.27 68.66 111.94 152 242.51 231.21 364.81-229.45-50.62-772.76-175.44-772.76-222.54zm482.49 1047.91c105.56-123.45 431.84-491.29 431.84-491.29s158.67 25.61 136.51 99c-39.64 131.26-424.43 316.36-568.35 392.29zM2085 1388.62c0 90.2-106.08 194.42-221.75 237.23L1605 1216.18c380.24 14.7 480 71.55 480 172.44z",
                fillColor: "black",
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 0.015,
                anchor: new google.maps.Point(1349, 1227),
            };

            let center = new google.maps.LatLng(
                    map.dataset.latitude,
                    map.dataset.longitude
                ),
                gMap,
                gMarker;

            mapOpts.center = center;
            mapOpts.zoom = parseInt(map.dataset.zoom);

            gMap = new google.maps.Map(map, mapOpts);

            gMarker = new google.maps.Marker({
                map: gMap,
                position: center,
                // icon: svgMarker,
                clickable: false,
            });
        });
    }
}

export function initMultiMarkerMaps() {
    const maps = document.querySelectorAll(".js-map-multi-markers");

    if (maps.length) {
        maps.forEach((el) => {
            const map = new SbsMap(el);
            map.init();
        });
    }
}

class SbsMap {
    constructor(el) {
        this.el = el;
        this.mapCanvas = false;
        this.mapOpts = {
            zoom: 15,
            scrollwheel: false,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scaleControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
            styles: mapStyles,
        };
        this.svgMarker = {
            path: "M2529.1 647c-111.72 17.91-1005.93 158.08-1005.93 158.08s.51-2.91.76-4.43C1587.05 418.75 1353.83 0 1057.69 0 787.84 0 584.28 260.38 857.28 760.61c23.68 43.4 47.35 85 77.47 136.15C469.15 969.46.4 1039 .4 1164.54c0 124.07 290.13 236.29 612 335 212.75 65.17 621.75 183.46 621.75 183.46s-268.32 296.6-434.47 485.69c-75.15 85.51-108.1 144.92-108.1 197.25 0 51.76 41.82 88.64 94.16 88.64 155.57 0 707.62-236.9 864.62-422.08l199 314h468.15l-381.44-605.13c417.83-93.31 584.32-264.64 584.32-355.36 0-127.15-237.7-242.55-951.21-286.92 278.55-78.44 918.47-249.72 1045.59-292.58 80-27 98.09-89.74 71.22-128.16-21.33-30.49-75.13-44.47-156.89-31.35zM1311.75 345.54c46.3 115.53 5.67 256.92-33.37 352.46L1177 537.19c-21.66-38.18-38.79-70.06-49.36-93.81-145.17-326.13 67.36-389.25 184.11-97.84zm-838.46 827.68c0-48.07 388.1-118.19 541.55-142.27 68.66 111.94 152 242.51 231.21 364.81-229.45-50.62-772.76-175.44-772.76-222.54zm482.49 1047.91c105.56-123.45 431.84-491.29 431.84-491.29s158.67 25.61 136.51 99c-39.64 131.26-424.43 316.36-568.35 392.29zM2085 1388.62c0 90.2-106.08 194.42-221.75 237.23L1605 1216.18c380.24 14.7 480 71.55 480 172.44z",
            fillColor: "black",
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.015,
            anchor: new google.maps.Point(1349, 1227),
        };
        this.mapMarkers = [];
        this.infoWindow = false;
        this.latlngbounds = new google.maps.LatLngBounds();
        this.markerClusterer = false;
        this.clustererOptions = {
            gridSize: 50,
            styles: [
                {
                    url: "/webkit/maps/cluster-icon.png",
                    width: 25,
                    height: 25,
                    textColor: "#ffffff",
                },
            ],
        };
        this.locations = window[el.dataset.locations];
        this.locationsCount = this.locations.length;
    }

    init() {
        // Create map canvas
        this.mapCanvas = new google.maps.Map(this.el, this.mapOpts);

        // Loop over all project locations, use lat/long or geocode address,
        // and save to markers array
        this.generateMapMarkers();
    }

    generateMapMarkers() {
        const _this = this;

        _this.locations.forEach((el, i) => {
            // const locationString = `${el.addressLine1},<br> ${el.addressLine2 ? el.addressLine2} ${el.city}, ${el.county}, ${el.postcode}`,
            const filteredLocationComponents = [
                    el.addressLine1,
                    el.addressLine2,
                    el.city,
                    el.county,
                    el.postcode,
                ].filter(Boolean),
                locationString = filteredLocationComponents.join(",<br>"),
                latitudeString = el.latitude,
                longitudeString = el.longitude,
                title = el.title,
                websiteUrl = el.websiteUrl,
                infoWindowContent = `<div class="min-w-[180px]"><h3 class="font-bold text-base">${title}</h3><p class="mt-1 text-sm">${locationString}</p><p class="mt-1 text-sm"><a href='${websiteUrl}' title='Visit ${title} website' class=" text-sbs-blue-800 underline transition-opacity hover:opacity-50">View website</a></p></div>`,
                geocoder = new google.maps.Geocoder();

            let locationLatLng = false;

            // Do we have any address data to work with?
            if (
                latitudeString === undefined &&
                longitudeString === undefined &&
                locationString === undefined
            ) {
                // We can't do anything so just continue to the next loop iteration
                return true;
            } else {
                // If we have the latitude and longitude points, lets use those
                if (
                    latitudeString !== undefined &&
                    latitudeString !== "" &&
                    longitudeString !== undefined &&
                    longitudeString !== ""
                ) {
                    locationLatLng = new google.maps.LatLng(
                        latitudeString,
                        longitudeString
                    );

                    _this.buildMarker(
                        locationLatLng,
                        title,
                        infoWindowContent,
                        i,
                        el
                    );
                } else {
                    // Geocode given address
                    geocoder.geocode(
                        { address: locationString },
                        function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                locationLatLng = results[0].geometry.location;

                                _this.buildMarker(
                                    locationLatLng,
                                    title,
                                    infoWindowContent,
                                    i,
                                    el
                                );
                            }
                        }
                    );
                }
            }
        });
    }

    buildMarker(latLng, title, infoWindowContent, i, item) {
        const _this = this,
            canvas = _this.mapCanvas;

        // Create actual marker on the map
        var mapMarker = new google.maps.Marker({
            position: latLng,
            map: _this.mapCanvas,
            title: title,
            optimized: true,
            icon: {
                path: "M1.49,12.23A11.42,11.42,0,0,1,.3,9.83,7.64,7.64,0,0,1,0,7.6,7.58,7.58,0,0,1,1,3.8,7.6,7.6,0,0,1,3.66,1,6.84,6.84,0,0,1,7.32,0,6.82,6.82,0,0,1,11,1a7.79,7.79,0,0,1,2.64,2.8,7.58,7.58,0,0,1,1,3.8,7.64,7.64,0,0,1-.3,2.23,11.38,11.38,0,0,1-1.18,2.4q-.62,1-2.52,3.84L7.32,20.72C5.8,18.64,4.7,17.09,4,16.07Q2.09,13.22,1.49,12.23ZM9.76,9.88a3,3,0,0,0,.9-2.21A3.09,3.09,0,0,0,7.59,4.56h0A3.11,3.11,0,0,0,4.5,7.67a3,3,0,0,0,.91,2.21,3,3,0,0,0,4.31,0l0,0",
                fillColor: "#FF885C",
                fillOpacity: 1,
                strokeOpacity: 0,
                scale: 1.25,
                anchor: new google.maps.Point(10, 28),
            },
        });

        _this.mapMarkers.push(mapMarker);

        // Add event listener fon marker click to open info window
        mapMarker.addListener("click", function () {
            // Close any open info windows
            if (_this.infoWindow) {
                _this.infoWindow.close();
            }

            // Set the infoWindow to use new content, then open it
            _this.infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent,
            });

            _this.infoWindow.open({
                anchor: mapMarker,
                canvas,
            });
        });

        // Extend the bounds of the map viewport to include this marker
        _this.latlngbounds.extend(latLng);

        // If we've added all the markers to our map let's set the final position and zoom level
        if (i === _this.locationsCount - 1) {
            _this.setMapPositionAndZoom();
        }
    }

    setMapPositionAndZoom() {
        const _this = this;

        if (_this.mapMarkers.length) {
            // Set the map centre point
            _this.mapCanvas.setCenter(_this.latlngbounds.getCenter());

            if (_this.mapMarkers.length > 1) {
                _this.mapCanvas.fitBounds(_this.latlngbounds);
            } else if (_this.mapMarkers.length == 1) {
                _this.mapCanvas.setZoom(15);
            }
        }

        // Setup clustering of markers
        // markerClusterer = new Clusterer.MarkerClusterer(mapCanvas, mapMarkers, clustererOptions);
    }
}
